<template>
  <el-container class="box">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList"/>
      <publicFoldSearch ref='searchChild' :searchList='searchList' v-on:getSearchObj='getSearchObj'  :rightEventList='platFormType==1?rightEventList:[]' @rightFunc='rightFunc'/>
      <el-tabs v-model="activeName" @tab-click="handleClick" v-if="userPlatForm=='organization'">
        <el-tab-pane label="全部模板逻辑" name="1"></el-tab-pane>
        <el-tab-pane label="公共模板逻辑" name="2"></el-tab-pane>
      </el-tabs>
    </div>
    <el-main class="bottom-tabel">
      <el-table :data="tableData" :header-cell-style="{
        background:'#FAFAFA',
        fontWeight: 'bold',
        color: '#333333',
        fontSize:'14px'
      }">
        <el-table-column align="center" min-width="100px" prop="no" label="编号">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.no" :disabled="scope.row.no&&scope.row.no.length>8?false:true"
              placement="top">
              <span class="fieldWidth">{{ scope.row.no | filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="name" label="逻辑名称">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.name" :disabled="scope.row.name&&scope.row.name.length>8?false:true"
              placement="top">
              <span class="fieldWidth">{{ scope.row.name | filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="typeNames" label="分类">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.typeNames"
              :disabled="scope.row.typeNames&&scope.row.typeNames.length>6?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.typeNames|filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="diseaseName" label="主适配病种">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.diseaseName"
              :disabled="scope.row.diseaseName&&scope.row.diseaseName.length>7?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.diseaseName|filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="subDiseaseNames" label="适配病种">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.subDiseaseNames"
              :disabled="scope.row.subDiseaseNames&&scope.row.subDiseaseNames.length>7?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.subDiseaseNames|filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="description" label="描述">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.description"
              :disabled="scope.row.description&&scope.row.description.length>8?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.description|filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="approvalUserName" label="归属">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.belongTo"
              :disabled="scope.row.belongTo&&scope.row.belongTo.length>8?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.belongTo|filterValgang }}</span>
            </el-tooltip>
          </template>

        </el-table-column>
        <el-table-column v-if="platFormType==1" align="center" prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status==1">草稿</span>
            <span v-if="scope.row.status==2">待审核</span>
            <span v-if="scope.row.status==3">{{scope.row.publishStatus?'已发布':"未发布"}}</span>

            <el-tooltip v-if="scope.row.status==4" :content="'驳回理由：'+scope.row.rejectReason" placement="top">
              <span class="fieldWidth">审核未通过</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="createUserName" label="创建人">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.createUserName"
              :disabled="scope.row.createUserName&&scope.row.createUserName.length>8?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.createUserName|filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="approvalUserName" label="审核人">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.approvalUserName"
              :disabled="scope.row.approvalUserName&&scope.row.approvalUserName.length>8?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.approvalUserName | filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="updateTime" label="更新时间">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.updateTime"
              :disabled="scope.row.updateTime && scope.row.updateTime.length>8?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.updateTime|filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="createTime" label="创建时间">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.createTime"
              :disabled="scope.row.createTime && scope.row.createTime.length>8?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.createTime|filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" width="200" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button @click="checkDetail(scope.row)" type="text" size="small">
              查看
            </el-button>
            <el-button @click="onCopyClick(scope.row)" v-show="platFormType==2" type="text" size="small">
              引用
            </el-button>

            <el-button @click="publishClick(scope.row)" type="text" size="small"
              v-if="platFormType==1&&(userid == scope.row.createUserId) && (scope.row.status==3)">
              {{scope.row.publishStatus?'取消发布':"发布"}}</el-button>
            <el-button @click="Approval(scope.row)" type="text" size="small"
              v-if="platFormType==1&&(userid == scope.row.createUserId) && (!scope.row.publishStatus)&&scope.row.status!=3">
              {{scope.row.status==2 ? '取消审核' : '提交审核'}}</el-button>
            <el-button v-if="platFormType==1&&scope.row.status==2&&userid != scope.row.createUserId"
              @click="NowApproval(scope.row)" type="text" size="small">立即审核</el-button>

          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="searchParams.current" :page-size="searchParams.size"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-main>

    <el-dialog :close-on-click-modal="false" @close="resetForm" title="新增基础信息" v-if="dialogFormVisible" key="100" center
      width="650px" :visible.sync="dialogFormVisible">
      <el-form :model="form" ref="ruleForm" :rules="formRule">
        <el-form-item label="逻辑名称：" prop="name" label-width="110px" size="medium">
          <el-input v-model="form.name" maxlength="30" placeholder="请输入逻辑名称，不能超过30个字" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="主适配病种：" prop="diseaseId" label-width="110px">
          <el-select v-model="form.diseaseId" @change="diseaseTypeChange" filterable placeholder="请输入关键词搜索主适配病种">
            <el-option v-for='(item,index) in diseaseListData' :key='index' :label='item.suborderName' :value="item.id"
              :disabled="item.id == '36112'">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="适配病种：" prop="subDiseaseIds" label-width="110px">
          <el-select v-model="form.subDiseaseIds" value-key="id" @change="diabledChange" filterable multiple placeholder="请输入关键词搜索适配病种">
            <el-option v-for='item in diseaseListData' :disabled="item.disabled" :key="item.id" :label="item.suborderName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类：" prop="typeIds" label-width="110px">
          <el-select v-model="form.typeIds" value-key="id" filterable multiple placeholder="请输入关键词搜索分类">
            <el-option style="max-width: 450px;" v-for="item in decisionType" :key="item.id" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述：" prop="description" label-width="110px">
          <el-input style="min-height: 120px;" type="textarea" placeholder="请输入描述" v-model="form.description"
            maxlength="500" show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="resetForm">重置</el-button>
        <el-button type="primary" @click="saveDescription">确 定</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog :close-on-click-modal="false" @close="resetSortForm" title="重新命名分类" key="101" center width="650px"
      :visible.sync="dialogFormType">
      <el-form :model="sortForm" ref="sortRuleForm" :rules="sortFormRule">
        <el-form-item label="分类：" prop="name" label-width="110px" size="medium">
          <el-input v-model="sortForm.name" maxlength="20" placeholder="请输入分类名称" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述：" prop="description" label-width="110px">
          <el-input style="min-height: 120px;" type="textarea" placeholder="请输入描述" v-model="sortForm.description"
            maxlength="500" show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="resetSortForm">重置</el-button>
        <el-button type="primary" @click="saveSort">确 定</el-button>
      </div>
    </el-dialog> -->
  </el-container>
</template>

<script>
import {
  decisionTreePage,
  decisionTreeInsertReturnId,
  decisionTypeList,
  decisionTreePublish,
  decisionTreeSubmitApproval,
  cancelApproval,
  quoteDecisionTree
} from "./api";
import local from "@/utils/local.js";
import { api_get_disease_type } from "@/api/ManagementPlan";
import { jsonp } from 'vue-jsonp';
export default {
  data() {
    return {
      breadList:[{name:'决策设置'},{name:'模板逻辑'}],
      rightEventList:[{eventName:'分类设置',eventValue:1,plain:true},{eventName:'新增信息',eventValue:2}],
      searchList: [
        {
          label: "逻辑名称",
          value: 1,
          paramName: "name",
          inputType: "input",
          maxNum: 20
        }, 
        {
          label: "分类",
          value: 2,
          paramName: "typeId",
          inputType: "select",
          optionData: []
        },

        {
          label: "主适配病种",
          value: 3,
          paramName: "diseaseId",
          inputType: "select",
          optionData: []
        },
        {
          label: "适配病种",
          value: 4,
          paramName: "subDiseaseIds",
          inputType: "select",
          optionData: []
        }, 
        {
          label: "创建人",
          value: 5,
          paramName: "createUserName",
          inputType: "input"
        },
        {
          label: "审核人",
          value: 6,
          paramName: "approvalUserName",
          inputType: "input"
        },
        {
          label: "更新时间",
          value: 7,
          paramName: "timeRange",
          inputType: "datetimerange",
          isTime:true,
          paramstartTime: "updateStartTime",
          paramEndTime: "updateEndTime"
        },
        {
          label: "创建时间",
          value: 8,
          paramName: "timeRange",
          inputType: "datetimerange",
          isTime:true,
          paramstartTime: "createStartTime",
          paramEndTime: "createEndTime"
        }, 
        {
          label: "编号",
          value: 9,
          paramName: "no",
          inputType: "input"
        } 
      ],
      statusObj:{
          label: "状态",
          value: 10,
          paramName: "status",
          inputType: "select", 
          optionData: [
            {
              label: "草稿",
              value: '1'
            },
            {
              label: "待审核",
              value: '2'
            },  
            {
              label: "审核未通过",
              value: '4'
            },
             {
              label: "未发布",
              value: '-1'
            }, 
            {
              label: "已发布",
              value: '-2'
            }
          ] 
        },
      searchParams: {
        size: 10,
        current: 1,
      },
      addBasicFlag:false,
      // listQuery1: {
      //   name: "",
      //   typeId: "",
      //   typeName: "",
      //   createTime: [],
      //   updateTime: [],
      //   diseaseId: "",
      //   diseaseName: "",
      //   suborderName: "",
      //   approvalUserName: "",
      //   createUserName: "",
      //   status: "",
      //   no: ""
      // },
      // listQuery: {
      //   platformId: "",
      //   name: "",
      //   status: "",
      //   diseaseId: "",
      //   diseaseName: "",
      //   suborderName: "",
      //   typeId: "",
      //   no: "",
      //   typeName: "",
      //   createStartTime: "",
      //   createEndTime: "",
      //   approvalUserName: "",
      //   createUserName: "",
      //   updateStartTime: "",
      //   updateEndTime: "",
      //   current: 1,
      //   size: 10
      // },
      userid: "",
      form: {
        description: "",
        name: "",
        diseaseId: "",
        subDiseaseIds: [],
        typeIds: [],
        diseaseName: ""
      },
      // sortForm: {
      //   name: "",
      //   description: ""
      // },
      dialogFormVisible: false,
      // dialogFormType: false,
      total: 0,
      tableData: [],
      decisionType: [],
      diseaseListData: [],
      formRule: {
        name: [
          {
            required: true,
            message: "请输入逻辑名称",
            trigger: "blur"
          }
        ],
        typeIds: [
          {
            required: true,
            message: "请选择分类",
            trigger: "change"
          }
        ],
        diseaseId: [
          {
            required: true,
            message: "请选择主适配病种",
            trigger: "change"
          }
        ],
        subDiseaseIds: [
          {
            required: true,
            message: "请选择适配病种",
            trigger: "change"
          }
        ]
      },
      sortFormRule: {
        name: [
          {
            required: true,
            message: "请输入分类名称",
            trigger: "blur"
          }
        ]
      },
      // hospitalList: [
      //   {
      //     label: "逻辑名称",
      //     value: 1
      //   },
      //   {
      //     label: "分类",
      //     value: 2
      //   },
      //   {
      //     label: "主适配病种",
      //     value: 3
      //   },
      //   {
      //     label: "适配病种",
      //     value: 10
      //   },
      //   {
      //     label: "创建人",
      //     value: 4
      //   },
      //   {
      //     label: "审核人",
      //     value: 5
      //   },
      //   {
      //     label: "更新时间",
      //     value: 6
      //   },
      //   {
      //     label: "创建时间",
      //     value: 7
      //   },
      //   {
      //     label: "状态",
      //     value: 8
      //   },
      //   {
      //     label: "编号",
      //     value: 9
      //   }
      // ],
      activeName: "1",
      platFormType: 1,
      userPlatForm: "platForm"
    };
  },
  created() {
    this.searchList.push(this.statusObj)
    this.init();
    this.classify("");
    this.userid = local.get("userid"); 
    api_get_disease_type().then(res => {
      if (res.code == 0) {
        this.diseaseListData = res.data;
        let arr = res.data.map(it => {
          return {
            label: it.suborderName,
            value: it.id
          };
        });  
        //主适配病种 通用不可选择
        this.searchList[2].optionData = JSON.parse(JSON.stringify(arr)).map(it=>{ 
          return {
            label: it.label,
            value: it.value,
            disabled:it.value=="36112"?true:false
          };
         })  
        this.searchList[3].optionData = arr;
      }
    }); 
  },
  mounted() {
    this.userPlatForm = this.$store.state.userPlatForm;
    //this.getCodeList(false)
  },
  methods: {
    getSearchObj(obj) {
      //清空之前合并过的条件
      this.searchParams = this.$options.data().searchParams;  
      this.searchParams = { ...this.searchParams, ...obj };  
      if (this.userPlatForm == 'organization' && this.activeName == 2) {
        this.searchParams.status = -2
        this.searchParams.companyId = this.$store.state.companyId 
      } 
      this.init();
    },
    diabledChange(e) {
      if (e.length == 0) {
        this.diseaseListData.forEach(item => {
          item.disabled = false
        })
        return
      }
      e.forEach(item => {
        if (item == '36112') {
          this.form.subDiseaseIds = []
          this.form.subDiseaseIds.push(item)
          this.diseaseListData.forEach(itam => {
            if (itam.suborderCode != '0') {
              itam.disabled = true
            }
          })
        }
      })
    },
    // goFenlei() {
    //   this.$router.push("/decisionPage/classificationSettings");
    // },
    classify(companyId) {
      decisionTypeList({ companyId: companyId }).then(res => { 
        this.decisionType = res.data; 
        let arr = res.data.map(it => {
          return {
            label: it.name,
            value: it.id, 
          };
        }); 
        this.searchList[1].optionData = arr;
      });
    },
    rightFunc(item) {
      if(item.eventValue == 1){
        this.$router.push("/decisionPage/classificationSettings");
      }else{
        this.dialogFormVisible = true;
      } 
    },
    // resetHandel() {
    //   // 机构并且公共模板逻辑
    //   if (this.userPlatForm == 'organization' && this.activeName == 2) { }
    //   else {
    //     for (var i = 1; i < 11; i++) {
    //       this.tagClose(i);
    //     }
    //   }
    //   this.listQuery.size = 10;
    //   this.listQuery.current = 1;
    //   this.listQuery = this.$options.data().listQuery;
    //   // 机构并且公共模板逻辑
    //   if (this.userPlatForm == 'organization' && this.activeName == 2) {
    //     this.listQuery.status = -2
    //     this.listQuery.companyId = this.$store.state.companyId
    //   }
    //   this.init();
    // },
    handleClick(tab) {
      this.searchParams.current = 1;
      if (tab.name == 1) {
        // this.searchParams.companyId = "";
        // this.searchParams.status = "";
        this.platFormType = 1;
        this.classify("");
        // this.init();
        if(this.searchList.length<10){
          this.searchList.push(this.statusObj)
        }
      } else if (tab.name == 2) {
        this.platFormType = 2;
        // this.searchParams.status = -2; 
        // this.searchParams.companyId = this.$store.state.companyId;
        this.classify(this.$store.state.companyId);
        // this.init();
        //公共模板时不展示 状态筛选条件，直接设置 已发布（-2）为默认状态
        this.searchList.pop(this.statusObj) 
      }
      this.$refs.searchChild.onResetClick()
    },
    // tagClose(v) {
    //   if (v == 1) {
    //     this.listQuery.name = "";
    //     this.listQuery1.name = "";
    //   }
    //   if (v == 2) {
    //     this.listQuery.typeId = "";
    //     this.listQuery1.typeId = "";
    //     this.listQuery.typeName = "";
    //   }
    //   if (v == 3) {
    //     this.listQuery.diseaseId = "";
    //     this.listQuery1.diseaseId = "";
    //     this.listQuery.diseaseName = "";
    //   }
    //   if (v == 4) {
    //     this.listQuery.createUserName = "";
    //     this.listQuery1.createUserName = "";
    //   }
    //   if (v == 5) {
    //     this.listQuery.approvalUserName = "";
    //     this.listQuery1.approvalUserName = "";
    //   }
    //   if (v == 6) {
    //     this.listQuery.updateStartTime = "";
    //     this.listQuery1.updateTime = [];
    //     this.listQuery.updateEndTime = "";
    //   }
    //   if (v == 7) {
    //     this.listQuery.createStartTime = "";
    //     this.listQuery1.createTime = [];
    //     this.listQuery.createEndTime = "";
    //   }
    //   if (v == 8) {
    //     this.listQuery.status = "";
    //     this.listQuery1.status = "";
    //   }
    //   if (v == 9) {
    //     this.listQuery.no = "";
    //     this.listQuery1.no = "";
    //   }
    //   if (v == 10) {
    //     this.listQuery.subDiseaseIds = "";
    //     this.listQuery.suborderName = "";
    //     this.listQuery1.subDiseaseIds = "";
    //     this.listQuery1.suborderName = "";
    //   }

    //   this.listQuery.platformId = "";
    //   this.queryHandel();
    // },
    // queryHandel() {
    //   if (this.listQuery.platformId == 1 && this.listQuery1.name.trim() != "") {
    //     this.listQuery.name = this.listQuery1.name;
    //   }
    //   if (this.listQuery.platformId == 2 && this.listQuery1.typeId != "") {
    //     this.listQuery.typeId = this.listQuery1.typeId;
    //     this.listQuery.typeName = "";
    //     for (var i = 0; i < this.decisionType.length; i++) {
    //       if (this.listQuery.typeId == this.decisionType[i].id) {
    //         this.listQuery.typeName = this.decisionType[i].name;
    //       }
    //     }
    //   }
    //   if (this.listQuery.platformId == 3 && this.listQuery1.diseaseId != "") {
    //     this.listQuery.diseaseId = this.listQuery1.diseaseId;
    //     this.listQuery.diseaseName = "";
    //     for (var i = 0; i < this.diseaseListData.length; i++) {
    //       if (this.listQuery.diseaseId == this.diseaseListData[i].id) {
    //         this.listQuery.diseaseName = this.diseaseListData[i].suborderName;
    //       }
    //     }
    //   }
    //   if (
    //     this.listQuery.platformId == 10 &&
    //     this.listQuery1.subDiseaseIds != ""
    //   ) {
    //     this.listQuery.subDiseaseIds = this.listQuery1.subDiseaseIds;
    //     this.listQuery.suborderName = "";
    //     for (var i = 0; i < this.diseaseListData.length; i++) {
    //       if (this.listQuery.subDiseaseIds == this.diseaseListData[i].id) {
    //         this.listQuery.suborderName = this.diseaseListData[i].suborderName;
    //       }
    //     }
    //   }
    //   if (
    //     this.listQuery.platformId == 4 &&
    //     this.listQuery1.createUserName.trim() != ""
    //   ) {
    //     this.listQuery.createUserName = this.listQuery1.createUserName;
    //   }
    //   if (
    //     this.listQuery.platformId == 5 &&
    //     this.listQuery1.approvalUserName.trim() != ""
    //   ) {
    //     this.listQuery.approvalUserName = this.listQuery1.approvalUserName;
    //   }
    //   if (this.listQuery.platformId == 6 && this.listQuery1.updateTime.length) {
    //     this.listQuery.updateStartTime = this.listQuery1.updateTime[0];
    //     this.listQuery.updateEndTime = this.listQuery1.updateTime[1];
    //   }
    //   if (this.listQuery.platformId == 7 && this.listQuery1.createTime.length) {
    //     this.listQuery.createStartTime = this.listQuery1.createTime[0];
    //     this.listQuery.createEndTime = this.listQuery1.createTime[1];
    //   }
    //   if (this.listQuery.platformId == 8 && this.listQuery1.status) {
    //     this.listQuery.status = this.listQuery1.status;
    //   }
    //   if (this.listQuery.platformId == 9 && this.listQuery1.no) {
    //     this.listQuery.no = this.listQuery1.no;
    //   }
    //   this.listQuery.size = 10;
    //   this.listQuery.current = 1;

    //   this.init();
    // },
    checkDetail(data) {
      this.setDecisionTreeObj(data.id);
      this.$router.push({
        path: "/decisionPage/TemplateSettings",
        query: {
          id: data.id,
          type: this.platFormType
        }
      });
    },
    onCopyClick(row) {
      this.$confirm("确定要引用该模板逻辑", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          quoteDecisionTree({ id: row.id }).then(res => {
            if (res.data) {
              this.$message.success("引用成功");
            } else {
              this.$message.success("引用失败");
            }
          });
        })
        .catch(() => { });
    },
    //存决策树id及区分模板编辑||患者编辑页面
    setDecisionTreeObj(id) {
      let obj = {
        pageName: "templatePage", //模板编辑：templatePage 患者编辑：patientPage
        decisionTreeId: id
      };
      localStorage.setItem("decisionTreeObj", JSON.stringify(obj));
    },
    NowApproval(data) {
      this.setDecisionTreeObj(data.id);
      this.$router.push({
        path: "/decisionPage/TemplateApproval",
        query: {
          id: data.id
        }
      });
    },
    publishClick(data) {
      if (data.publishStatus) {
        decisionTreePublish({
          decisionTreeId: data.id,
          isPublish: false
        }).then(res => {
          this.$message.success("操作成功");
          this.init();
        });
      } else {
        decisionTreePublish({
          decisionTreeId: data.id,
          isPublish: true
        }).then(res => {
          this.$message.success("操作成功");
          this.init();
        });
      }
    },
    Approval(data) {
      if (data.status == 2 || data.status == 3) {
        cancelApproval(data.id).then(res => {
          this.$message.success("操作成功");
          this.init();
        });
      } else {
        decisionTreeSubmitApproval({
          id: data.id
        }).then(res => {
          this.$message.success("操作成功");
          this.init();
        });
      }
    },
    saveDescription() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let obj;
          if (this.form.subDiseaseIds.length) {
            let subArr = [];
            this.diseaseListData.forEach(item => {
              this.form.subDiseaseIds.forEach(v => {
                if (item.id === v) {
                  subArr.push(item.suborderName);
                }
              });
            });
            obj = {
              description: this.form.description,
              name: this.form.name,
              diseaseId: this.form.diseaseId,
              diseaseName: this.form.diseaseName,
              subDiseaseIds: this.form.subDiseaseIds.join(","),
              subDiseaseNames: subArr.join(","),
              typeIds: this.form.typeIds.join(",")
            };
          } else {
            obj = {
              description: this.form.description,
              name: this.form.name,
              diseaseId: this.form.diseaseId,
              diseaseName: this.form.diseaseName,
              typeIds: this.form.typeIds.join(",")
            };
          }
          console.log(this.addBasicFlag,"this.addBasicFlag");
          if(this.addBasicFlag) return;
          this.addBasicFlag = false
          decisionTreeInsertReturnId(obj).then(res => {
            this.$message.success("操作成功");
            this.setDecisionTreeObj(res.data);
            this.$router.push({
              path: "/decisionMain",
              query: {
                decisionTreeId: res.data
              }
            });

            this.resetForm();
            this.dialogFormVisible = false;
            this.init();
            this.addBasicFlag = true
          })
          .catch(e=> {
            this.addBasicFlag = true
          })
        } else {
          this.addBasicFlag = true
          return false;
        }
      });
    },
    //mm66
    // saveSort() {
    //   this.$refs["sortRuleForm"].validate(valid => {
    //     if (valid) {
    //       //对接改
    //       debugger;
    //       let obj;
    //       // decisionTreeInsertReturnId(obj).then(res => {
    //       //   this.$message.success("操作成功");
    //       //   this.resetSortForm();
    //       //   this.dialogFormType = false;
    //       //   this.init();
    //       // });
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    // diseaseTypeChange1(v) {
    //   this.listQuery1.diseaseName = "";
    //   for (var i = 0; i < this.diseaseListData.length; i++) {
    //     if (v == this.diseaseListData[i].id) {
    //       this.listQuery1.diseaseName = this.diseaseListData[i].suborderName;
    //     }
    //   }
    // },
    // diseaseTypeChange2(v) {
    //   this.listQuery1.suborderName = "";
    //   for (var i = 0; i < this.diseaseListData.length; i++) {
    //     if (v == this.diseaseListData[i].id) {
    //       this.listQuery1.suborderName = this.diseaseListData[i].suborderName;
    //     }
    //   }
    // },
    diseaseTypeChange(v) {
      this.form.diseaseName = "";
      for (var i = 0; i < this.diseaseListData.length; i++) {
        if (v == this.diseaseListData[i].id) {
          this.form.diseaseName = this.diseaseListData[i].suborderName;
        }
      }
    },
    init() {
      // this.listQuery.platformId = "";
      decisionTreePage(this.searchParams).then(res => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    resetForm() {
      this.form.typeIds = [];
      this.form.subDiseaseIds = [];
      this.$refs["ruleForm"].resetFields();
    },
    // resetSortForm() {
    //   this.$refs["sortRuleForm"].resetFields();
    // },
    // addInfo() {
    //   this.dialogFormVisible = true;
    // },
    handleSizeChange(val) {
      this.searchParams.size = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.searchParams.current = val;
      this.init();
    }
  }
};
</script>

<style scoped lang="less">
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}
/deep/.el-tabs__header {
  margin: 0 !important;
}

/deep/ .el-tabs__nav-wrap::after {
  background-color: #fff;
}

.a-tag {
  border-radius: 11px;
  margin-right: 15px;
}

.fieldWidth {
  display: inline-block;
  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

/deep/.el-textarea textarea {
  min-height: 120px !important;
}

.header {
  background-color: #fff;
  margin-bottom: 16px;
  padding: 0 24px;
 

  .float-right {
    float: right;
  }
}

.bottom-tabel {
  background-color: #fff;
  padding: 16px 17px 0;
  margin: 0 15px;
}

/deep/.el-pagination {
  text-align: right;
  margin-top: 30px;
  margin-right: 30px;
  padding-bottom: 20px;
}

/deep/.el-select {
  width: 100%;
}

.dialog-footer {
  text-align: center;
  margin-top: 40px;
}
</style>
